const extractBrokerDeepLinks = (data, contacts) => {
  const response = [];

  (data.brokerListingLinks || []).forEach(listingLinkData => {
    const contact = contacts.find(contact => contact.brokerId === listingLinkData.brokerId);
    if (!contact || !contact.brokerName) return;

    response.push({
      url: listingLinkData.url,
      brokerId: listingLinkData.brokerId,
      brokerName: contact.brokerName
    });
  });

  return response;
};

export default extractBrokerDeepLinks;
